import { render, staticRenderFns } from "./MessageTip.vue?vue&type=template&id=1094a1d5&scoped=true&"
import script from "./MessageTip.vue?vue&type=script&lang=js&"
export * from "./MessageTip.vue?vue&type=script&lang=js&"
import style0 from "./MessageTip.vue?vue&type=style&index=0&id=1094a1d5&prod&lang=scss&"
import style1 from "./MessageTip.vue?vue&type=style&index=1&id=1094a1d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1094a1d5",
  null
  
)

export default component.exports